import React from 'react';
import classnames from 'classnames';
import { Table, Panel, FormControl, Button } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import LabeledCheckbox from '../LabeledCheckbox.jsx';

import {
	setProjectFilterUseDynamicDates,
	setProjectFilterStartDate,
	setProjectFilterEndDate,
	setProjectFilterDynamicRange
} from '../../context/projectFilter.js';
import { useStateValue } from '../../context/state.jsx';

const FilterByDate = () => {
	const [{ projectFilter }, dispatch] = useStateValue();
	const handleUseDynamicDatesChange = e => {
		dispatch(setProjectFilterUseDynamicDates(e.target.checked));
	};

	const handleStartDateChange = (dates, string, flatpickr) => {
		const startDate = dates.length ? dates[0].valueOf() : 0;
		if (flatpickr.isOpen) flatpickr.close(); // Necessary for some reason for mobile browsers
		dispatch(setProjectFilterStartDate(startDate));
	};

	const handleEndDateChange = (dates, string, flatpickr) => {
		const endDate = dates.length ? dates[0].valueOf() : 0;
		if (flatpickr.isOpen) flatpickr.close(); // Necessary for some reason for mobile browsers
		dispatch(setProjectFilterEndDate(endDate));
	};

	const handleDynamicRangeChange = e => {
		dispatch(setProjectFilterDynamicRange(e.target.value));
	};

	const startDate = projectFilter.startDate ? projectFilter.startDate : '';
	const endDate = projectFilter.endDate ? projectFilter.endDate : '';

	const dateRangeGrid = projectFilter.useDynamicDates
		? (
			<Table>
				<tbody>
					<tr>
						<td>
							<FormControl
								componentClass="select"
								value={projectFilter.dynamicRange}
								onChange={handleDynamicRangeChange}>
								<option value="">Choose ...</option>
								<option value="Today">Today</option>
								<option value="Next 2 Days">Next 2 Days</option>
								<option value="Current Week">Current Week</option>
								<option value="Next Week">Next Week</option>
								<option value="Next 2 Weeks">Next 2 Weeks</option>
								<option value="Next 3 Weeks">Next 3 Weeks</option>
								<option value="Current Month">Current Month</option>
								<option value="Next Month">Next Month</option>
							</FormControl>
						</td>
					</tr>
				</tbody>
			</Table>
		)
		: (
			<Table>
				<tbody>
					<tr>
						<td>Start:</td>
						<td className={classnames('datePickerColumn', {empty: startDate === ''})}>
							<Flatpickr
								options={{
									dateFormat: 'd-M-Y',
									onChange: handleStartDateChange,
									wrap: true
								}}
								value={startDate}>
								<input type="text" className="datePicker form-control" data-input />
								<Button bsStyle="primary" bsSize="xsmall" className="datePickerClear glyphicon glyphicon-remove-circle" data-clear></Button>
							</Flatpickr>
						</td>
					</tr>
					<tr>
						<td>Finish:</td>
						<td className={classnames('datePickerColumn', {empty: endDate === ''})}>
							<Flatpickr
								options={{
									dateFormat: 'd-M-Y',
									onChange: handleEndDateChange,
									wrap: true
								}}
								value={endDate}>
								<input type="text" className="datePicker form-control" data-input />
								<Button bsStyle="primary" bsSize="xsmall" className="datePickerClear glyphicon glyphicon-remove-circle" data-clear></Button>
							</Flatpickr>
						</td>
					</tr>
				</tbody>
			</Table>
		);
	return (
		<Panel
			className={classnames('dateRange', {activeFilter: (projectFilter.useDynamicDates && projectFilter.dynamicRange) || projectFilter.startDate || projectFilter.endDate})}>
			<Panel.Heading>
				<Panel.Title toggle>Dates</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<LabeledCheckbox
						text="Dynamic Dates"
						checked={projectFilter.useDynamicDates}
						onChange={handleUseDynamicDatesChange} />
					<div className="dateWrapper">
						{dateRangeGrid}
					</div>
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByDate;
